import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-1 text-sm text-foreground-500">漫画爱好者正在热议的话题，来看看大家都在聊什么</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 bg-background-50 rounded-xl px-4 py-3 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/40 transition-all duration-200 cursor-pointer"
            >
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.name}</span>
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-line text-accent-500"></i>{item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}